module.exports = __webpack_public_path__ + "static/media/rsz_tribalbooks.53ed6046.webp";